import api from './api';

export const getCustomers = (params) => api.get('/customers', { params });
export const getCustomer = (id) => api.get(`/customers/${id}`);
export const createCustomer = (customerData) => api.post('/customers', customerData);
export const updateCustomer = (id, customerData) => api.put(`/customers/${id}`, customerData);
export const deleteCustomer = (id) => api.delete(`/customers/${id}`);
export const getTransactions = (id, params) => api.get(`/customers/${id}/transactions`, { params });
export const recordPayment = (id, paymentData) => api.post(`/customers/${id}/payment`, paymentData);
export const addCredit = (id, creditData) => api.post(`/customers/${id}/credit`, creditData);
export const writeOff = (id, data) => api.post(`/customers/${id}/write-off`, data);
export const blockCustomer = (id, data) => api.put(`/customers/${id}/block`, data);
export const getReminders = () => api.get('/customers/reminders');
export const createReminder = (reminderData) => api.post('/customers/reminders', reminderData);
export const getCreditSummary = () => api.get('/customers/credit-summary');
export const exportCustomers = (params) => api.get('/customers/export', {
  params,
  responseType: 'blob',
});
